import { render, staticRenderFns } from "./TheMinChatDisplay.vue?vue&type=template&id=48d40e1c&scoped=true"
import script from "./TheMinChatDisplay.vue?vue&type=script&lang=js"
export * from "./TheMinChatDisplay.vue?vue&type=script&lang=js"
import style0 from "./TheMinChatDisplay.vue?vue&type=style&index=0&id=48d40e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d40e1c",
  null
  
)

export default component.exports